// extracted by mini-css-extract-plugin
export default {"submitFooter":"m5wIg___FormSubmitter-module__submitFooter"};